import { render, staticRenderFns } from "./HospitalDoctorApp.vue?vue&type=template&id=f1c8f16e"
import script from "./HospitalDoctorApp.vue?vue&type=script&lang=js"
export * from "./HospitalDoctorApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports